import * as React from 'react'
import { Autocomplete, GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { MapsLocation } from './MapsLocation';

const containerStyle = {
    width: '100%',
    height: '200px'
};
interface Props {
    apiKey: string
    value: MapsLocation[]
}
const libraries: ("drawing" | "geometry" | "localContext" | "places" | "visualization")[] = ["places"];
export const MapsRoutesPreview = (props: Props) => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: props.apiKey,
        libraries: libraries
    })
    const [map, setMap] = React.useState<google.maps.Map | null>(null)
    const fitBound = (map: google.maps.Map, value: MapsLocation[]) => {
        const minMaxLat = props.value.reduce((res, next) => {
            if (next.lat && next.lat > res.maxLat)
                res.maxLat = next.lat
            if (next.lat && next.lat < res.minLat)
                res.minLat = next.lat
            if (next.lng && next.lng > res.maxLng)
                res.maxLng = next.lng
            if (next.lng && next.lng < res.minLng)
                res.minLng = next.lng
            return res
        }, { minLat: 90, maxLat: -90, minLng: 180, maxLng: -180 })
        const minCenter = new window.google.maps.LatLng({ lat: minMaxLat.minLat, lng: minMaxLat.minLng })
        const maxCenter = new window.google.maps.LatLng({ lat: minMaxLat.maxLat, lng: minMaxLat.maxLng })
        map.fitBounds(new window.google.maps.LatLngBounds(minCenter, maxCenter));
        setMap(map)
    }
    React.useEffect(() => {
        if (isLoaded && map) {
            fitBound(map, props.value)
        }
    }, [isLoaded, map, props.value])
    const onLoad = React.useCallback(function callback(map: google.maps.Map) {
        fitBound(map, props.value)
    }, [props.value])
    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])

    const center = props.value.find(x => x.lat && x.lng)
        ? new google.maps.LatLng(props.value.find(x => x.lat && x.lng)!.lat!, props.value.find(x => x.lat && x.lng)!.lng!)
        : new google.maps.LatLng(0, 0)
    return <>
        {isLoaded
            ? <GoogleMap
                mapContainerStyle={containerStyle}
                center={center}
                zoom={12}
                onLoad={onLoad}
                onUnmount={onUnmount}
            >
                {props.value.map((x, index) =>
                    <Marker
                        key={index}
                        label={(index + 1).toString()}
                        position={new google.maps.LatLng(x.lat ?? 0, x.lng ?? 0)}
                        animation={google.maps.Animation.DROP}
                    />
                )}
            </GoogleMap>
            : null}
    </>
}
